import React from 'react';

import { Input, SCREENS, useMediaQuery, useT } from '@repo/common';
import PostSection from '../PostSection';

const PerksAndBenefits = ({ textValues, setTextValues, errors }) => {
  const t = useT();
  const isMobile = useMediaQuery(`(max-width: ${SCREENS.tabletH - 0.02}px)`);

  const handleTextValueChange = (fieldName) => (e) => {
    setTextValues((prev) => ({
      ...prev,
      [fieldName]: e.target.value,
    }));
  };

  return (
    <PostSection
      title={t('Perks and Benefits (optional)', '복리후생 (선택)')}
      withBottomBorder={false}
      paddingClassName='py-4 tabletH:pt-[50px] tabletH:pb-[64px]'
    >
      <Input
        data-validation-field='perksAndBenefits'
        className='w-full'
        as='textarea'
        label={isMobile ? t('Benefits overview*', '복리후생 개요*') : ''}
        placeholder={t(
          "e.g. Personal follow-up during your career, Buddy-ship program during your first 6 months, Catalogue with a wide variety of trainings for hard & soft skills, Private language classes, Unlimited access to an E-learning platform (Udemy, O'Reilly,...)",
          '예: 경력 개발 1:1 코칭, 입사 후 6개월 버디 프로그램, 직무·소프트 스킬 교육 지원, 개인 어학 수업, 온라인 학습 플랫폼 무제한 이용 (Udemy, O\'Reilly 등)',
        )}
        value={textValues.perksAndBenefits}
        state={errors.perksAndBenefits ? 'failed' : 'default'}
        showStatusIcon={false}
        message={errors.perksAndBenefits}
        onChange={handleTextValueChange('perksAndBenefits')}
        maxLength={2000}
        textareaMinHeight='232px'
        textareaRows={8}
      />
    </PostSection>
  );
};

export default PerksAndBenefits;
